import { render, staticRenderFns } from "./shareComp.vue?vue&type=template&id=6c6c3ef0&scoped=true"
import script from "./shareComp.vue?vue&type=script&lang=js"
export * from "./shareComp.vue?vue&type=script&lang=js"
import style0 from "./shareComp.vue?vue&type=style&index=0&id=6c6c3ef0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_coffee-script@1.12.7_css-loader@5.2.7_webpack@5.75_86376c8867defa2ab34ac3cb7ab0bafc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c3ef0",
  null
  
)

export default component.exports